<template>
  <div>
    <div style="border-radius: 16px">
      <div class="media-list">
        <el-row type="flex" align="bottom">
          <el-col :span="22">
            <div class="breadcrumb-bar">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/audioResources' }">音频资源上传</el-breadcrumb-item>
                <el-breadcrumb-item v-for="(item, index) in albumLevel" :key="index" @click.native="backLevel(item)"
                  style="cursor: pointer;font-weight: bold;"
                  :class="(albumLevel.length - 1) == index ? '' : 'backLevel'">{{ item.name }}</el-breadcrumb-item>
                <!-- <el-breadcrumb-item v-if="doWhy === 'edit'">修改专辑资源</el-breadcrumb-item>
                <el-breadcrumb-item v-if="doWhy === 'add'">新建资源</el-breadcrumb-item> -->
              </el-breadcrumb>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="tableList">
      <el-form :inline="true" :model="formResource" class="searchForm" style="padding-left: 20px">
        <el-form-item label="批量上传音频">
          <el-upload ref="upload" class="upload_file" action="/aries-api/resource/upload"
            :before-upload="onBeforeAudioUpload" :on-success="onSuccessAudioUpload" :on-error="onError"
            :on-remove="handleRemove" :show-upload-list="false" :data="uploadData" :on-change="handleChange" multiple>
            <el-button type="primary">
              上传音频资源
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item>
          <el-button size="small" type="primary" @click="submitUpload">上传文件夹</el-button>
          <input type="file" ref="uploadInput" multiple webkitdirectory directory v-show="false" @change="onFileChange">
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="createFolder" v-if="albumLevel.length < 4">
            创建文件夹
          </el-button>
        </el-form-item>
      </el-form>
      <p style="
          padding-left: 20px;
          font-size: 13px;
          position: relative;
          bottom: 18px;
          color: rgb(144, 147, 153);
        ">
        注:<span style="margin-left: 4px">1.一个系列，音频+文件夹最多可上传300个 </span><br /><span
          style="margin-left: 20px">2.付费音频请上传.mp3格式，硬件设备下载音频后会做加密保护
        </span>
        <br /><span style="margin-left: 20px">3.听力熊T3，T4系列不支持多层专辑显示
        </span>
      </p>
      <el-table :data="albumData" style="width: 700px" :row-key="refresh" v-show="albumData.length != 0">
        <el-table-column type="index" width="100" label="序号" align="center">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-around;align-items: center;">
              <b>{{ scope.$index + 1 }}</b>
              <img src="../../assets/folder.png" alt="" v-if="scope.row.albumType == 'folder'" width="40">
              <img src="../../assets/audio.png" alt="" v-if="scope.row.albumType == 'audio'" width="40">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="文件名" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.albumType == 'folder' && scope.row.changeName"
              v-model="scope.row.name"></el-input>
            <span v-if="scope.row.albumType == 'folder' && !scope.row.changeName" style="cursor: pointer;"
              @click="editChildSong(scope.row)">{{ scope.row.name }}</span>
            <span v-if="scope.row.albumType == 'audio' || !scope.row.albumType">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="状态" align="center" width="150">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <Progress :percent="audioUploadPercent" :status="audioUploadStatus"
              v-if="scope.row.albumType == 'audio' || !scope.row.albumType" />
          </template>
          <!-- <template scope="scope" v-if="audioUploadPercent == 100">
            <el-button size="mini" type="success">上传成功</el-button>
          </template> -->
          <!-- <template>
            <el-progress :percentage="100"></el-progress>
          </template> -->
        </el-table-column>
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="scope">
            <i v-if="scope.row.albumType == 'audio'&&currentAudioIndex!==scope.$index&&(scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='tpm'||scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='mp3'||scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='TPM'||scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='MP3')" style="font-size:20px;margin-right:10px;cursor:pointer;" class="el-icon-video-play" @click.prevent="onPlayTTS(scope.row, scope.$index)"></i>
            <i v-if="scope.row.albumType == 'audio'&&currentAudioIndex==scope.$index&&(scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='tpm'||scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='mp3'||scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='TPM'||scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)=='MP3')" style="font-size:20px;margin-right:10px;cursor:pointer;" class="el-icon-video-pause" @click.prevent="onPauseTTS(scope.row, scope.$index)"></i>
            <span v-if="scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)!=='tpm'&&scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)!=='mp3'&&scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)!=='TPM'&&scope.row.name.slice(scope.row.name.lastIndexOf('.') + 1)!=='MP3'" style="margin-right:35px;"></span>
            <span :id="'audio'+scope.$index">
              <audio></audio>
            </span>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"
              v-if="scope.row.albumType == 'audio' || !scope.row.albumType">删除</el-button>
            <el-tooltip class="item" effect="dark" content="重命名" placement="top-start">
              <el-button size="mini" type="primary" @click="reAlbumName(scope.$index, scope.row)"
                v-if="scope.row.albumType == 'folder' && scope.row.id && !scope.row.changeName">重命名</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="保存" placement="top-start">
              <el-button size="mini" type="primary" @click="creatChildSong(scope.$index, scope.row)"
                v-if="scope.row.albumType == 'folder' && scope.row.changeName">√</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
              <el-button size="mini" type="primary" @click="editChildSong(scope.row)"
                v-if="scope.row.albumType == 'folder' && scope.row.id && !scope.row.changeName"><i
                  class="el-icon-edit"></i></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
              <el-button size="mini" type="danger" @click="deleteChildSong(scope.$index, scope.row)"
                v-if="scope.row.albumType == 'folder' && !scope.row.changeName">×</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="sortShow">
        <el-form label-width="120px">
          <el-form-item label="排序方式:">
            <el-radio v-model="radioTo" label="1"><span
                style="font-weight: bolder; font-size: 90%; color: black">资源上传正序</span>
              <br></el-radio>
            <el-radio v-model="radioTo" label="2">
              <span style="font-weight: bolder; font-size: 90%; color: black">资源名称正序</span></el-radio>
              <br>
            <el-radio v-model="radioTo" label="3">
              <span style="font-weight: bolder; font-size: 90%; color: black">资源上传倒序</span></el-radio>
            <el-radio v-model="radioTo" label="4">
              <span style="font-weight: bolder; font-size: 90%; color: black">资源名称倒序</span></el-radio>
            <p>可拖拽手动进行排序</p>
            <p style="position: relative;bottom: 15px;">文件夹和音频混排时，文件夹排在音频前面</p>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-button type="primary" style="margin-left: 45%; margin-top: 30px; margin-bottom: 50px" @click="commitAudio('')"
      :loading="loadingBtn">确认</el-button>
    <el-button @click="cancelEdit">取消</el-button>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      sendStatus: false,
      radioTo: "1",
      doWhy: "",
      albumId: "", //当前的系列歌单id
      dbId: "",
      currentAudioIndex: null, // 记录播放状态
      folderData: [],// 创建文件夹
      resourceData: [], //音频资源
      albumData: [], //当前系列歌单下所有的音频资源+下一级的系列歌单
      formResource: {},
      uploadData: {
        // isOnlyMP3: "false",
        // pdfToPng: "false",
        appId: this.$API.APPID,
        compress: true,
      },
      nameData: [],
      uploadNum: 0,
      numAll: 0,
      audioUploadNum: 0,
      audioEveryProgress: 0,
      audioUploadPercent: 10,
      audioUploadStatus: "active",
      albumArr: [],
      ids: [],
      newAlbumData: [],
      addAlbumData: [],
      sortShow: false,
      // refresh: "",
      sortable: "",
      newDataArr: [],
      limitMessage: true,
      totalFileSize: 0,
      totalFileSizeLimit: 0,
      loadingBtn: false,
      oldalbumData: [],
      changeName: false,
      albumLevel: [],
      folderData2: [],// 资源名称正序文件夹
      resourceData2: [],// 资源名称正序音频资源
      folderData3: [],// 资源上传倒序文件夹
      resourceData3: [],// 资源上传倒序音频资源
      folderData4: [],// 资源名称倒序文件夹
      resourceData4: [],// 资源名称倒序音频资源
    };
  },
  created() {
    this.doWhy = this.$route.query.doWhy;
    this.albumId = Number(this.$route.query.id);
    this.dbId = Number(this.$route.query.dbId);
    this.totalFileSize = Number(this.$route.query.totalFileSize);
    this.totalFileSizeLimit = Number(this.$route.query.totalFileSizeLimit);
    this.fetchCurrentRes()
    this.fetchSeriesplaylists()
    this.albumResList(this.albumId).then(() => {
      if (this.$route.query.doWhy == "edit" && this.albumData.length != 0) {
        this.sortShow = true;
      }
    });
  },
  mounted() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    if (this.$route.query.doWhy == "edit") {
      this.rowDrop();
    }
  },
  watch: {
    radioTo(newVal, oldVal) {
      this.$set(this, "currentAudioIndex", null);
      let audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
          i !== this && i.pause();
          i.currentTime = 0;
      })
      if (newVal == "2") {
        //资源名称正序
        this.folderData2=JSON.parse(JSON.stringify(this.folderData))
        this.resourceData2=JSON.parse(JSON.stringify(this.resourceData))

        // console.log(this.sortable);
        //文件夹排序
        if (this.folderData2.length > 0) {
          this.folderData2 = this.customSortFunction(this.folderData2)
          this.albumData = [...this.folderData2, ...this.resourceData2]
        }
        //资源排序
        if (this.resourceData2.length > 0) {
          this.resourceData2 = this.customSortFunction(this.resourceData2)
          this.albumData = [...this.folderData2, ...this.resourceData2]
        }

        // this.newDataArr = JSON.parse(JSON.stringify(this.albumData));
        // console.log(this.newDataArr, "this.newDataArr");
        // // console.log(this.sortable);
        // //文件夹排序
        // if (this.folderData.length > 0) {
        //   this.folderData = this.customSortFunction(this.folderData)
        // }
        // //资源排序
        // if (this.resourceData.length > 0) {
        //   this.resourceData = this.customSortFunction(this.resourceData)
        // }




        // var rankArr = [];
        // // 数字0开头
        // var zeroArr = this.albumData.filter((ele, index) => {
        //   if (Number(ele.name.substr(0, 1)) === 0) {
        //     debugger;

        //     return !isNaN(Number(ele.name.substr(0, 1)));
        //   }
        // });
        // // 数字0开头排序
        // zeroArr = zeroArr.sort((a, b) => {
        //   debugger;
        //   // return parseInt(a.name) - parseInt(b.name)
        //   return a.name.match(/^\d*/)[0] - b.name.match(/^\d*/)[0];
        //   // a.name.replace(/[^0-9]/gi, "") - b.name.replace(/[^0-9]/gi, "")
        // });
        // rankArr = zeroArr;
        // // 数字非0开头
        // var numArr = this.albumData.filter((ele, index) => {
        //   if (Number(ele.name.substr(0, 1)) !== 0) {
        //     return !isNaN(Number(ele.name.substr(0, 1)));
        //   }
        // });
        // // 数字非0开头排序
        // numArr = numArr.sort((a, b) => {
        //   // debugger
        //   // console.log(a.name.match(/^\d*/)[0],b.name.match(/^\d*/)[0]);
        //   // return a.name.match(/^\d*/)[0] - b.name.match(/^\d*/)[0];
        //   return a.name.localeCompare(b.name);
        // });
        // // 汉字开头
        // var reg = new RegExp("^[\u4e00-\u9fa5]");
        // var wordArr = this.albumData.filter((ele, index) => {
        //   debugger
        //   return reg.test(ele.name.substr(0, 1));
        // });
        // // 汉字开头排序
        // wordArr = wordArr.sort((a, b) => {
        //   console.log(a.name.localeCompare(b.name),a.name,b.name);
        //   return a.name.localeCompare(b.name);
        // });
        // // 大写字母开头
        // var regUpper = /^[A-Z]+$/;
        // var upperArr = this.albumData.filter((ele, index) => {
        //   return regUpper.test(ele.name.substr(0, 1));
        // });
        // // 大写字母开头排序
        // upperArr = upperArr.sort((a, b) => {
        //   return a.name.localeCompare(b.name);
        // });
        // // 剩余其他的开头
        // var otherArr = this.albumData.filter((ele, index) => {
        //   return (
        //     isNaN(Number(ele.name.substr(0, 1))) &&
        //     !reg.test(ele.name.substr(0, 1)) &&
        //     !regUpper.test(ele.name.substr(0, 1))
        //   );
        // });
        // // 剩余其他的开头排序
        // otherArr = otherArr.sort((a, b) => {
        //   return a.name.localeCompare(b.name);
        // });
        // this.albumData = rankArr;
        // this.albumData = this.albumData.concat(
        //   numArr,
        //   wordArr,
        //   upperArr,
        //   otherArr
        // );
      } else if(newVal == "1") {
        //资源上传正序

        // this.folderData = this.newDataArr.filter(item => item.albumType == "folder")
        // this.resourceData = this.newDataArr.filter(item => item.albumType == "audio")
        // this.$nextTick(() => {
        //   this.rowDrop();
        // });

        if (this.folderData.length > 0) {
          this.albumData = [...this.folderData, ...this.resourceData]
        }
        
        if (this.resourceData.length > 0) {
          this.albumData = [...this.folderData, ...this.resourceData]
        }
      }else if(newVal == "3"){
        //资源上传倒序
        this.folderData3=this.folderData.slice().reverse()
        this.resourceData3=this.resourceData.slice().reverse()
        if (this.folderData3.length > 0) {
          this.albumData = [...this.folderData3, ...this.resourceData3]
        }
        
        if (this.resourceData3.length > 0) {
          this.albumData = [...this.folderData3, ...this.resourceData3]
        }
      }else{
        //资源名称倒序
        this.folderData2=JSON.parse(JSON.stringify(this.folderData))
        this.resourceData2=JSON.parse(JSON.stringify(this.resourceData))

        //文件夹排序
        if (this.folderData2.length > 0) {
          this.folderData2 = this.customSortFunction(this.folderData2)
        }
        //资源排序
        if (this.resourceData2.length > 0) {
          this.resourceData2 = this.customSortFunction(this.resourceData2)
        }

        this.folderData4=this.folderData2.slice().reverse()
        this.resourceData4=this.resourceData2.slice().reverse()
        if (this.folderData4.length > 0) {
          this.albumData = [...this.folderData4, ...this.resourceData4]
        }
        
        if (this.resourceData4.length > 0) {
          this.albumData = [...this.folderData4, ...this.resourceData4]
        }
      }
    },
    folderData: {
      // 文件夹数据
      handler(val) {
        this.albumData = [...val, ...this.resourceData];
      },
    },
    resourceData: {
      // 资源数据
      handler(val) {
        this.albumData = [...this.folderData, ...val];
      },
    },
    albumData: {
      handler(val) {
        if (val.length > 0) {
          this.sortShow = true;
        } else {
          this.sortShow = false;
        }
      },
      deep: true,
      immediate: true,
    }
  },

  methods: {
    onFileChange(e) {
      console.log(e);
      // this.folder = e.target.files[0];

    },
    refresh() {
      return Math.random();
    },
    submitUpload() {
      this.$refs.uploadInput.click();
    },
    //创建文件夹
    createFolder() {
      if (this.albumData.length >= 300) {
        this.$message.error("文件夹创建失败，音频+文件夹数量超过上限");
        return;
      }
      if (this.radioTo == "2"||this.radioTo == "3"||this.radioTo == "4") {
        this.radioTo = "1";
      }
      this.folderData.unshift({ name: "", albumType: "folder", changeName: true })
    },
    fetchParentRes(type) {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          dbId: this.dbId,
          id: [this.albumId],
        }
        this.$axios
          .post("/aries-api/album/list", params)
          .then(async (response) => {
            if (response.data.result == 0) {
              console.log(response.data.data, "response.data.data");
              if (response.data.data.list[0].type == 0||type== "delete" && response.data.data.list[0].type == 2) {
                console.log(response.data.data.list[0].type);
                await this.changeaAlbumType(response.data.data.list[0], type)
                resolve()
                //修改父级的type
              }else {
                //继续
                resolve()
              }
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      })
    },
    changeaAlbumType(data, type) {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          type: type == 'delete' ? 0 : 2,// 0普通歌单 1 专辑 2 系列歌单
          dbId: this.dbId,
          id: data.id,
          name: data.name,
          pid: data.pid,
        };
        this.$axios
          .post("/aries-api/album/save", params)
          .then((response) => {
            resolve(response.data.data.id);
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    //创建子级歌单
    async creatChildSong(index2, row) {
      await this.fetchParentRes()
      if (!row.name) {
        this.$message.error("请输入文件名称");
        return
      } else {
        console.log(row.name, this.folderData, "row.name");
        let isNameExist = this.albumData.filter((item, index) => index2 != index).filter(item => item.albumType == "folder").some(item => item.name == row.name);
        if (isNameExist) {
          this.$message.error("文件夹名称已存在");
          return
        }
      }
      let params = {
        appId: this.$API.APPID,
        pid: this.albumId,
        type: 0,// 0普通歌单 1 专辑 2 系列歌单
        dbId: this.dbId,
        id: row.id ? row.id : 0,
        status: 0,
        name: row.name,
        status: 1,
      }
      this.$axios
        .post("/aries-api/album/save", params)
        .then((response) => {
          console.log(response.data.data);
          this.$message.success("文件夹保存成功");
          // this.$set(this.albumData, index2, { ...row, changeName: false, id: response.data.data.id });
          this.$set(this.folderData, index2, { ...row, changeName: false, id: response.data.data.id });
          if (this.radioTo == "2"||this.radioTo == "3"||this.radioTo == "4") {
            this.radioTo = "1"
            this.fetchSeriesplaylists()
          }
          // this.fetchSeriesplaylists()
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    //重命名
    reAlbumName(index, row) {
      this.$set(this.albumData, index, { ...row, changeName: true });
    },
    editChildSong(row) {
      this.radioTo = "1"
      this.commitAudio(row, true)

    },
    //删除子级歌单
    deleteChildSong(index, row) {
      if (row.id) {
        this.$Modal.confirm({
          title: "确认删除？",
          content: "<ul><li>删除文件夹会删除下所有资源，请确认是否删除文件夹</li></ul>",
          onOk: () => {
            let params = {
              appId: this.$API.APPID,
              ids: [row.id],
              is_delete_res: 1, //删除专辑下所有音频
            };
            this.$axios
              .post("/aries-api/album/delete", params)
              .then((response) => {
                let m = response.data;
                if (m.result == 0) {
                  this.fetchSeriesplaylists('delete');
                  this.$message.success("删除成功!");
                } else {
                  ApiMessage(this, m.err, "error");
                }
              })
              .catch((error) => {
                ApiMessage(this, error.toString(), "error");
              });
          },
        });
      } else {
        this.folderData.splice(this.getArrIndex(this.folderData, row), 1);
      }
    },
    //获取当前进入的资源
    fetchCurrentRes() {
      let params = {
        appId: this.$API.APPID,
        dbId: this.dbId,
        id: [this.albumId],
      }
      this.$axios
        .post("/aries-api/album/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            if (response.data.data.list[0]) {
              this.albumLevel.push(response.data.data.list[0])
            }
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    //返回资源
    backLevel(row) {
      this.albumLevel.splice(this.getArrIndex(this.albumLevel, row) + 1);
      if (row.id !== this.albumId) {
        this.radioTo = "1"
        this.commitAudio(row)
      }

    },
    // 获取系列歌单
    fetchSeriesplaylists(type) {
      let params = {
        appId: this.$API.APPID,
        dbId: this.dbId,
        needFileSizeLimit: 1,
        // type: 2, //获取子级系列歌单
        pid: this.albumId,
        pageSize: 500,
      };
      this.$axios
        .post("/aries-api/album/list", params)
        .then((response) => {
          if (response.data.result == 0) {
            console.log(response.data.data);
            let _data = response.data.data.list.map(item => {
              return { ...item, albumType: "folder" }
            })
            this.folderData = JSON.parse(JSON.stringify(_data));
            console.log(this.folderData, "folderData");
            if (type == 'delete' && this.folderData.length == 0) {
              this.fetchParentRes(type)
            }
            // this.pageTotal = response.data.data.pager.total;
            // this.totalFileSize = response.data.data.totalFileSize;
            // this.totalFileSizeLimit = response.data.data.totalFileSizeLimit;

          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    //删除文件夹
    deleteFolder(index, row) {
      if (row.type == "folder") {
        this.albumData.splice(index, 1)
      } else {
        this.albumData.splice(index, 1)
      }
    },
    extractNumber(number) {
      // 提取数字
      // 假设number是一个包含数字的字符串，例如："123.mp3"
      if (
        number.name.substring(0, number.name.lastIndexOf(".")).match(/\d+/g) !=
        null
      ) {
        return number.name
          .substring(0, number.name.lastIndexOf("."))
          .match(/\d+/g);
      } else {
        return null;
      }
    },
    customSortFunction(arr) {
      //localeCompare() 方法用于比较两个字符串，并根据排序规则确定这两个字符串的顺序
      return arr.sort((a, b) => {
        let a1 = null;
        let a2 = null;
        let b1 = null;
        let b2 = null;
        if (this.extractNumber(a) != null) {
          if (this.extractNumber(a).length == 1) {
            a1 = this.extractNumber(a)[0];
          } else if (this.extractNumber(a).length > 1) {
            a1 = this.extractNumber(a)[0];
            a2 = this.extractNumber(a)[1];
          }
        }
        if (this.extractNumber(b) != null) {
          if (this.extractNumber(b).length == 1) {
            b1 = this.extractNumber(b)[0];
          } else if (this.extractNumber(b).length > 1) {
            b1 = this.extractNumber(b)[0];
            b2 = this.extractNumber(b)[1];
          }
        }
        if (Number(a1) && Number(b1)) {
          if (Number(a1) == Number(b1)) {
            if (Number(a2) && Number(b2)) {
              if (Number(a2) == Number(b2)) {
                return a.name.localeCompare(b.name);
              } else {
                return Number(a2) < Number(b2) ? -1 : 1;
              }
            } else {
              return a.name.localeCompare(b.name);
            }
          } else {
            // debugger
            return Number(a1) < Number(b1) ? -1 : 1;
          }
        } else {
          // debugger;
          return a.name.localeCompare(b.name);
        }
      });
    },
    //音频播放
    onPlayTTS(content, _index) {
      let audio = document.getElementById('audio'+_index).getElementsByTagName("audio")[0];
      this.$set(this, "currentAudioIndex", null);
      let audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
          i !== this && i.pause();
          i.currentTime = 0;
      })
      if(content.content){
        if(content.name.slice(content.name.lastIndexOf('.') + 1)=="tpm"||content.name.slice(content.name.lastIndexOf('.') + 1)=="TPM"){
          let params = {
            tpmUrl:content.content
          }
          this.$http.post(this.$API.MP3_PLAY, params).then(function (response) {
            let _res = response.data;
            if (_res.rc == 0) {
              audio.src = _res.data.mp3Url
            }else{
              this.$message.error(_res.data.msg)
              return
            }
          }, function (error) {
            ApiMessage(this, error.toString(), "error");
            return
          })
        }else{
          audio.src = content.content;
        }
        audio.play();
        this.$set(this, "currentAudioIndex", _index);
        audio.addEventListener("ended", () => {
            this.$set(this, "currentAudioIndex", null);
        });
      }else if(content.url){
        if(content.name.slice(content.name.lastIndexOf('.') + 1)=="tpm"||content.name.slice(content.name.lastIndexOf('.') + 1)=="TPM"){
          let params = {
            tpmUrl:content.url
          }
          this.$http.post(this.$API.MP3_PLAY, params).then(function (response) {
            let _res = response.data;
            if (_res.rc == 0) {
              audio.src = _res.data.mp3Url
            }else{
              this.$message.error(_res.data.msg)
              return
            }
          }, function (error) {
            ApiMessage(this, error.toString(), "error");
            return
          })
        }else{
          audio.src = content.url;
        }
        audio.play();
        this.$set(this, "currentAudioIndex", _index);
        audio.addEventListener("ended", () => {
            this.$set(this, "currentAudioIndex", null);
        });
      }
    },
    onPauseTTS(content, _index) {
        this.$set(this, "currentAudioIndex", null);
        let audio = document.getElementById('audio'+_index).getElementsByTagName("audio")[0];
        audio.pause();
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      console.log("tbody", tbody);
      const _this = this;
      _this.sortable = Sortable.create(tbody, {
        // onUpdate: function (/**Event*/ evt) {
        //   _this.refresh = Math.random();

        //   // same properties as onEnd
        // },
        // 文件夹只能再文件夹上拖拽，音频在音频上拖拽
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.albumData.splice(oldIndex, 1)[0];
          _this.albumData.splice(newIndex, 0, currRow);
          console.log(newIndex, _this.albumData[newIndex - 1], _this.albumData[newIndex + 1], currRow.albumType, _this.albumData[newIndex - 1]);
          if ((currRow.albumType == "folder" && _this.albumData[newIndex - 1] && _this.albumData[newIndex - 1].albumType == "audio") || (currRow.albumType == "audio" && _this.albumData[newIndex + 1] && _this.albumData[newIndex + 1].albumType == "folder")) {
            _this.albumData.splice(newIndex, 1);
            _this.albumData.splice(oldIndex, 0, currRow);
          }
          // this.folderData = _this.albumData.filter(item => item.albumType == 'folder')
          // this.resourceData = _this.albumData.filter(item => item.albumType == 'audio')
          console.log(_this.albumData, "rowDrop");
          _this.$set(_this, "currentAudioIndex", null);
          let audios = document.getElementsByTagName('audio');
          [].forEach.call(audios, function (i) {
              i !== this && i.pause();
              i.currentTime = 0;
          })
        },
      });
    },
    // 查询专辑/系列歌单资源列表
    albumResList() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          id: this.albumId,
          page: 1,
          pageSize: 500,
          sort: "sort,asc;"
        };
        this.$axios
          .post("/aries-api/album/resList", params)
          .then((response) => {
            // console.log(response.data.data.list);
            this.audioUploadPercent = 100;
            this.audioUploadStatus = "success";
            let _data = response.data.data.list.filter(
              (item) => item.clevel == 5
            );
            this.resourceData = _data.map(item => {
              return { ...item, albumType: "audio" }
            })
            console.log(this.resourceData, "type:'audio'");
            this.newAlbumData = JSON.parse(
              JSON.stringify(
                _data.map(item => {
                  return { ...item, albumType: "audio" }
                })
              )
            );
            resolve();
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    onBeforeAudioUpload(file) {
      // console.log(this.uploadNum);
      // 上传数量
      this.radioTo = "1";
      //uploadNum 当前上传的文件数量
      console.log(this.albumData, this.albumData.length, this.uploadNum);
      if (this.albumData.length + this.uploadNum > 300) {
        if (this.limitMessage) {
          alert("资源上传失败，音频+文件夹数量超过上限");
          this.limitMessage = false;
          setTimeout(() => {
            this.limitMessage = true;
          }, 1000);
        }
        return false;
      }
      //名称重复
      this.nameData = this.resourceData.map((item) => {
        return item.name;
      });
      if (this.nameData.includes(file.name)) {
        alert(file.name + "文件名重复");
        return false;
      } else {
        this.nameData.push(file.name);
        this.totalFileSize += file.size;
        console.log(this.totalFileSize);
        // console.log(decodeURIComponent(encodeURIComponent(file.name)),"encodeURIComponent(file.name)");
        // this.uploadData.name = encodeURIComponent(file.name);
      }
      // 上传大小
      console.log(this.totalFileSize);
      if (this.totalFileSize > this.totalFileSizeLimit) {
        // debugger;
        if (this.limitMessage) {
          // debugger;
          alert("资源上传失败，可使用空间已达上限");
          this.limitMessage = false;
          setTimeout(() => {
            this.limitMessage = true;
          }, 1000);
        }
        return false;
      }
      console.log(file, file.name.split("."), this.albumData.length);
      let validExts = ["mp3", "tpm", "m4a", "wav", "wma", "acc", "aac"];
      let arr = file.name.split(".");
      let fileExt = arr[arr.length - 1];
      fileExt = fileExt.toLocaleLowerCase();
      if (!validExts.includes(fileExt)) {
        // debugger;
        alert("音频上传格式只支持" + validExts.join(",") + "格式");
        return false;
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        alert("上传单个文件大小不能超过50MB!");
        return false;
      }
      this.audioUploadNum += 1;
      this.audioEveryProgress = parseInt(100 / this.audioUploadNum);
      this.audioUploadPercent = 0;
      this.audioUploadStatus = "active";
      this.handleSpinCustom();
    },

    // 全屏loading
    handleSpinCustom() {
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              props: {
                type: "",
                size: 24,
              },
            }),
            h(
              "p",
              {
                style: {
                  color: "#666",
                  fontSize: "14px",
                  height: "80px",
                  width: "400px",
                  lineHeight: "80px",
                  backgroundColor: "#ffff",
                },
              },
              (this.sendStatus ? "资源保存中 " : "资源上传中 ") +
              this.numAll +
              "/" +
              this.uploadNum
            ),
          ]);
        },
      });
    },
    onSuccessAudioUpload(response, file, fileList) {
      // console.log(response, file, fileList);
      this.nameData = this.resourceData.map((item) => {
        return item.name;
      });

      if (!this.nameData.includes(file.name) && response.result == 0) {
        let _data = response.data[0]
        this.resourceData.push({ ..._data, albumType: "audio" });
      }
      if (response.result != 0) {
        alert(file.name + response.msg);
        this.$refs.upload.abort(); //强制取消上传
        this.audioUploadNum -= 1;
        this.audioUploadPercent += this.audioEveryProgress;
        this.audioUploadPercent = 100;
        this.audioUploadStatus = "success";
        this.$Spin.hide();
        this.numAll = 0;
        return;
      }
      this.numAll += 1;
      this.audioUploadNum -= 1;
      this.audioUploadPercent += this.audioEveryProgress;
      // console.log(
      //   this.audioUploadNum,
      //   this.audioEveryProgress,
      //   this.audioUploadPercent
      // );
      if (this.audioUploadNum === 0) {
        this.audioUploadPercent = 100;
        this.audioUploadStatus = "success";
        this.$Spin.hide();
        this.numAll = 0;
        // console.log(this.resourceData);
        this.$nextTick(() => {
          this.rowDrop();
        });
      }
    },
    onError(err, file, fileList) {
      if (err) {
        // this.$refs.upload.abort(); //强制取消上传
        this.totalFileSize -= file.size;
        this.audioUploadNum -= 1;
        this.audioUploadPercent += this.audioEveryProgress;
        this.audioUploadPercent = 100;
        this.audioUploadStatus = "success";
        this.$Spin.hide();
        this.numAll = 0;
      }
    },
    // 上传数量
    handleChange(file, fileList) {
      let upload_file = document.getElementsByClassName("upload_file");
      if (upload_file && upload_file.length > 0) {
        let upload = upload_file[0].getElementsByTagName("input");
        if (
          upload &&
          upload.length > 0 &&
          upload[0].files &&
          upload[0].files.length > 0
        ) {
          this.uploadNum = upload[0].files.length;
          // console.log(this.uploadNum, upload[0].files,"this.uploadNum");
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleDelete(index, row) {
      this.resourceData.splice(this.getArrIndex(this.resourceData, row), 1);
      // this.albumData.splice(index, 1);
      // if (this.radioTo == "2") {
      //   this.newDataArr.splice(this.getArrIndex(this.newDataArr, row), 1);
      // }
      if (row.rid) {
        this.ids.push(row.rid);
      }
    },

    getArrIndex(arr, obj) {
      let index = null;
      let key = Object.keys(obj)[0];
      arr.every(function (value, i) {
        if (value[key] === obj[key]) {
          index = i;
          return false;
        }
        return true;
      });
      return index;
    },
    // 解除关联
    deleteAlbum(ids, row) {
      return new Promise((resolve, reject) => {
        let res = [];
        for (let i = 0; i < ids.length; i++) {
          let temp = {
            dbId: this.dbId,
            id: ids[i],
          };
          res.push(temp);
        }
        let paramsTwo = {
          appId: this.$API.APPID,
          id: this.albumId,
          resList: res,
        };
        this.$axios
          .post("/aries-api/album/delRes", paramsTwo)
          .then((response) => {
            console.log(response);
            let m = response.data;
            if (m.result == 0) {
              if (!row) {
                this.$Message.success("删除成功!");
              }
              this.ids = []
              resolve();
            } else {
              ApiMessage(this, m.err, "error");
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    // 删除资源
    deleteResource(ids) {
      let res = [];
      for (let i = 0; i < ids.length; i++) {
        let temp = {
          dbId: this.dbId,
          id: ids[i],
        };
        res.push(temp);
      }
      let params = {
        appId: this.$API.APPID,
        ids: res,
      };

      this.$axios
        .post("/aries-api/resource/delete", params)
        .then((response) => { });
    },

    cancelEdit() {
      this.albumResList();
      this.$router.push({
        path: "/audioResources",
      });
    },
    // 批量添加资源  --------  参数填写不够！！无法使用
    // fetchBatchAdd() {
    //   console.log(this.albumData);

    //   let params = {
    //     appId: this.$API.APPID,
    //     id: 0,
    //     dbId: this.dbId,
    //     type: 1,
    //     clevel: 5,
    //     play_type: 0,
    //   };
    //   let newAlbumData = this.albumData.map((item) => {
    //     if (item.name != "" && item.url != "") {
    //       params.name = item.name;
    //       params.content = item.url;
    //     }
    //     return params
    //   });
    //   console.log(newAlbumData, "批量增加");
    //   this.$axios
    //     .post("/aries-api/resource/batchAdd", newAlbumData)
    //     .then((response) => {
    //       console.log(response);
    //       if (response.data.result == "0") {
    //       }
    //     })
    //     .catch((error) => {
    //       ApiMessage(this, error.toString(), "error");
    //     });
    // },

    // 提交
    async commitAudio(row, status) {
      this.$set(this, "currentAudioIndex", null);
      let audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
          i !== this && i.pause();
          i.currentTime = 0;
      })
      let index = 0;
      this.oldalbumData = []
      if (this.ids.length != 0) {
        //删除资源及解除关联资源
        await this.deleteResource(this.ids);
        await this.deleteAlbum(this.ids, row);
      }
      if (this.folderData.length > 0) {
        this.sortAlbum(row)
      }
      // this.albumData.forEach((item) => {
      //   if (item.dbId && item.rid) {
      //     this.albumArr.push({
      //       dbId: item.dbId,
      //       id: item.rid,
      //     });
      //   }
      // });
      // debugger;
      // 查找是否存在需要添加到歌单的资源
      /**
       * newAlbumData 之前已经存在的音频资源
       * resourceData 目前展示所有的资源
       * addAlbumData 需要添加到歌单的资源
       * _resourceData 当前页所有的音频资源（包括已上传的和未上传的）
       */
      let _resourceData = this.albumData.filter(item => item.albumType == 'audio')

      this.addAlbumData = _resourceData.filter(
        (item) => !this.newAlbumData.some((ele) => ele.id === item.id)
      );
      // console.log(this.addAlbumData, "this.addAlbumData");
      this.uploadNum = this.addAlbumData.length;
      // console.log(this.albumData, "this.albumData", this.newAlbumData, "this.newAlbumData", this.addAlbumData, "this.addAlbumData", this.oldalbumData, "this.oldalbumData", this.resourceData, "resourceData",_resourceData,"_resourceData");
      if (_resourceData.length != 0 && this.addAlbumData.length == 0) {
        //新增0条资源，调用接口有可能改变顺序，所以需要重新发请求
        this.oldalbumData = JSON.parse(JSON.stringify(_resourceData));
        this.albumAddResource(row, status);
        return
      }
      if (
        (this.albumData.length == 0 && this.ids.length == 0) ||
        this.albumData.length == 0 ||
        this.addAlbumData.length == 0
      ) {
        // debugger
        if (row) {
          this.albumId = row.id
          if (status) {
            this.fetchCurrentRes()
          }
          this.fetchSeriesplaylists()
          this.albumResList()
        }

      } else {
        // debugger;
        // 查找再次上传音频中已存在的音频资源
        let existenceList = await this.searchResource();
        let obj = {};
        let resultAlum = []; //未查询到的音频资源  需要save
        //查找出来批量上传已存在的音频信息
        let existenceNewArr = existenceList.reduce((pre, cur) => {
          obj[cur.org_mid] ? "" : (obj[cur.org_mid] = true && pre.push(cur));
          return pre;
        }, []);
        console.log(existenceNewArr, this.addAlbumData, 'existenceNewArr', obj, "obj");
        if (existenceNewArr.length > 0) {
          // //查找出来批量上传已存在的音频信息的org_mid
          // let saveAlbumData = existenceNewArr.map((item) => {
          //   this.numAll += 1;
          //   // this.albumArr.push({ dbId: this.dbId, id: item.id });
          //   return item.org_mid;
          // });
          //查找之前已存在的rid  
          this.oldalbumData = _resourceData.map((item, index) => {
            // debugger;
            let res = existenceNewArr.find((item2) => {
              return item2.org_mid == item.md5;
            });
            if (res && res.id) {
              return Object.assign(_resourceData[index], {
                rid: res.id,
              });
            } else {
              return _resourceData[index];
            }
          });

          console.log(this.oldalbumData, "this.oldalbumData");
          // resultAlum = this.addAlbumData.filter(
          //   (item) => !saveAlbumData.includes(item.md5)
          // );
          resultAlum = this.addAlbumData.map(
            (item) => {
              let objItem = JSON.parse(JSON.stringify(item))
              existenceNewArr.forEach(ele => {
                if (ele.org_mid == item.md5) {
                  objItem.url = ele.content
                }
              })
              return objItem
            }
          );
        } else {
          resultAlum = JSON.parse(JSON.stringify(this.addAlbumData));
        }
        console.log(resultAlum, "resultAlum", "需要save的音频");
        if (resultAlum.length == 0) {
          this.albumAddResource(row, status);
        }
        if (resultAlum.length > 0) {
          let fun = async (i) => {
            // debugger;
            this.sendStatus = true;
            this.numAll += 1;
            this.handleSpinCustom();
            console.log(resultAlum[i]);
            let objRes = await this.sendAddResource(resultAlum[i]);
            if (this.oldalbumData.length > 0) {
              this.oldalbumData = this.oldalbumData.map((item, index) => {
                // console.log(item.md5, resultAlum[i].md5);
                if (item.md5 == resultAlum[i].md5) {
                  return Object.assign(this.oldalbumData[index], {
                    rid: objRes.id,
                  });
                } else {
                  return this.oldalbumData[index];
                }
              });
            } else {
              this.oldalbumData = _resourceData.map((item, index) => {
                // debugger;
                console.log(item.md5, resultAlum[i].md5);
                if (item.md5 == resultAlum[i].md5) {
                  return Object.assign(this.albumData[index], {
                    rid: objRes.id,
                  });
                } else {
                  return _resourceData[index];
                }
              });
            }

            console.log(this.oldalbumData, "this.oldalbumData提交save的数据");
            // this.albumArr.push(objRes);
            if (index == resultAlum.length - 1) {
              this.loadingBtn = false;
              this.albumAddResource(row, status);
              this.$Spin.hide();
              this.numAll = 0;
              this.sendStatus = false;
            } else {
              this.loadingBtn = true;
              fun(++index);
            }
          };
          fun(index);
        }
      }
    },

    //搜索当前dbid 的音频资源
    searchResource() {
      console.log(this.addAlbumData);
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          dbId: [this.dbId],
        };
        if (this.addAlbumData.length > 0) {
          params.org_mids = this.addAlbumData.map((item) => {
            return item.md5;
          });
        }
        this.$axios
          .post("/aries-api/resource/list", params)
          .then((response) => {
            if (response.data.result == "0") {
              resolve(response.data.data.list);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      });
    },
    // 保存音频资源
    sendAddResource(audioConent, index) {
      console.log(audioConent);
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          id: 0,
          dbId: this.dbId,
          type: 1,
          clevel: 5, //上架状态
          play_type: 0,
        };
        if (audioConent != null) {
          if (audioConent.name != "") {
            params.name = audioConent.name;
          }
          if (audioConent.url != "") {
            params.content = audioConent.url;
          }
          if (audioConent.size != "") {
            params.size = audioConent.size;
          }
          if (audioConent.md5 != "") {
            params.org_mid = audioConent.md5;
          }
        }

        this.$axios
          .post("/aries-api/resource/save", params)
          .then((response) => {
            console.log(response.data.data, "ciel=====>>>>>>>");
            if (response.data.result == "0") {
              resolve(response.data.data);
            } else {
              alert(audioConent.name + response.data.msg);
              this.loadingBtn = false;
              this.$Spin.hide();
              this.numAll = 0;
              this.sendStatus = false;
              this.albumAddResource();
              reject(null);
            }
            // if (index !== this.addAlbumData.length - 1) {
            //   console.log("this.sendAddResource(audioConent, ++index);");
            //   this.sendAddResource(this.addAlbumData[index + 1], ++index);
            // } else {
            //   let newArr = [];
            //   // debugger;

            //   this.albumAddResource();
            // }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    // 给专辑添加资源
    albumAddResource(row, status) {
      // console.log(this.albumArr);
      // debugger;
      let newArr = this.oldalbumData.map((item, index) => {
        return {
          id: item.rid,
          dbId: this.dbId,
          sort: index + 1,
        };
      });
      let params = {
        appId: this.$API.APPID,
        id: this.albumId,
      };
      if (newArr.length != 0) {
        params.resList = newArr;
      } else {
        alert("资源为空,请确认保存成功后进行关联!");
        this.albumResList();
        return;
      }
      this.$axios
        .post("/aries-api/album/saveRes", params)
        .then(async (response) => {
          if (response.data.result == "0") {
            this.radioTo="1"
            if (row) {
              this.albumId = row.id
              if (status) {
                this.fetchCurrentRes()
              }
              this.fetchSeriesplaylists()
              this.albumResList()
            } else {
              this.fetchSeriesplaylists()
              await this.albumResList();
              this.$message.success("资源保存成功");
            }
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    //系列歌单下的子级歌单排序
    sortAlbum(row) {
      let params = {
        appId: this.$API.APPID,
        id: this.albumId,
      }
      let _data = this.albumData.filter((item, index) => {
        return item.albumType == "folder"
      })
      params.subAlbumList = _data.map((item, index) => {
        return {
          id: item.id,
          sort: (index + 1)
        }
      })
      this.$axios
        .post("/aries-api/album/addSubAlbum", params)
        .then((response) => {
          if (response.data.result == "0") {
            if (!row) {
              this.$message.success("保存成功");
            }
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    }
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";

.upload_file {
  .el-upload-list__item {
    display: none !important;
  }

  .el-upload-list__item-name {
    display: none !important;
  }

  .el-upload-list__item .el-icon-upload-success {
    display: none !important;
  }
}

.ivu-spin-fix {
  background-color: rgba(0, 0, 0, 0.8) !important;
}

.backLevel> {
  .el-breadcrumb__inner:hover {
    color: #409EFF !important;
  }
}
</style>


// WEBPACK FOOTER //
// addAlbums.vue?3b48a492